import React, { Component } from 'react';
import { Redirect, Route } from 'react-router-dom';

import {
    IonApp,
    IonRouterOutlet,
    IonTabs,
    IonTabBar,
    IonTabButton,
    IonIcon,
    IonLabel,
} from '@ionic/react';

import { IonReactRouter } from '@ionic/react-router';

import { ScreenOrientation } from '@ionic-native/screen-orientation';


/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */

import './theme/app.css';
// import './theme/variables.css';

/** =========================================
 *  -- COMPONENTS
    ========================================= */
import { 
    personCircleOutline, informationCircleOutline, homeOutline 
} from 'ionicons/icons';

// import Toasts from './components/Toasts/Toasts';

/** =========================================
 *  -- PAGES
    ========================================= */
import LoadingPage from './pages/LoadingPage/LoadingPage';

// generic pages
import Home from './pages/Home/Home';
import Admin from '@acri-tools/react-tools/pages/Admin/Admin';
import ConsortiumPage from './pages/ConsortiumPage/ConsortiumPage';

// auth
import Login from './pages/Login/Login';
import UpdateEmail from './pages/UpdateEmail/UpdateEmail';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import Account from './pages/Account/Account';
import Contact from './pages/Contact/Contact';
import UpdatePassword from './pages/UpdatePassword/UpdatePassword';

/** =========================================
 *  -- METHODS
    ========================================= */
import { article_manager, file_manager, MOBILE_MODE } from './_utils/config';
import Async from 'react-async';

// mobile
import { isMobile } from 'react-device-detect';
import {
    Plugins,
    StatusBarStyle
} from '@capacitor/core';

// Redux
import { connect } from 'react-redux';

import { admin_routes } from './pages/Admin/Admin';
import routes from './_utils/routes';
import { logo } from './_utils/images';
import Menu from '@acri-tools/react-tools/components/Menu/Menu';

import { createBrowserHistory } from 'history';
import { on_app_mount, on_app_unmount } from '@acri-tools/react-tools';
import { setArticleManager, setCatalog, setRouting } from '@acri-tools/react-tools/actions/';
import Toasts from '@acri-tools/react-tools/components/Toasts/Toasts';
import { initLogin, isAdmin, isLoggedIn } from '@acri-tools/react-tools/utils/login';
import { AdminOnly, RequiresLogin, RequiresLogout } from '@acri-tools/react-tools/utils/routing';
import ServicePage from './pages/ServicePage/ServicePage';
import PBPage from './pages/PBPage/PBPage';
import KPIPage from './pages/KPIPage/KPIPage';
import ActionsTrackingPage from './pages/ActionsTrackingPage/ActionsTrackingPage';
import DocumentsPage from './pages/DocumentsPage/DocumentsPage';
import KPI1 from './pages/KPIs/KPI1/KPI1';
import KPI2 from './pages/KPIs/KPI2/KPI2';
import KPI3 from './pages/KPIs/KPI3/KPI3';
import KPI4 from './pages/KPIs/KPI4/KPI4';
import KPI5 from './pages/KPIs/KPI5/KPI5';
import KPI6 from './pages/KPIs/KPI6/KPI6';
import KPI7 from './pages/KPIs/KPI7/KPI7';
import KPI8 from './pages/KPIs/KPI8/KPI8';
import { load_product_types } from './_utils/product_types';
import './_utils/request';


// testing rebuild

interface Props {
    // ======== REDUX =========
    // notifications?: any,
    // setArticleManager?:any
    // setCatalog?:any
    setRouting?:any
    login?:any
}
const history = createBrowserHistory();

class App extends Component<Props, {}> {
    defaultLoggedinRedirect = () => {
        return (
            isMobile ?
                <Redirect to="/" />
                :
                <Redirect to="/" />
        )
    }
    componentDidMount() {
        on_app_mount(history);

        // Plugins.LocalNotifications.requestPermission();
        // Plugins.Network.addListener('networkStatusChange',(status)=> {
        //     alert(`connection : ${status.connected}`)
        // })
        // if (MOBILE_MODE) {
        //     ScreenOrientation.lock(ScreenOrientation.ORIENTATIONS.PORTRAIT);
        //     Plugins.StatusBar.setStyle({
        //         style: StatusBarStyle.Dark
        //     })
        // }

        load_product_types()

    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.login?.user !== this.props.login?.user) {
            if(this.props.login?.user){
                console.log('setting user token',this.props.login);
                // SET USER TOKEN
                Plugins.Storage.set({
                    key: 'user_token',
                    value: this.props.login?.user?.token
                });
            }
        }
    }

    componentWillUnmount(){
        on_app_unmount();
    }
    
    render() {

        // console.log('history',this.props.history);
        return (
            <IonApp id="app" className={isMobile ? 'mobile' : undefined}>
                
                <Async 
                    promiseFn={async()=>{ 
                        let user = await initLogin();
                    }}>
                    {
                        ({ data, error, isLoading }) => {
                            if (isLoading) {
                                return (<LoadingPage />);
                            }
                            
                            else {
                                // return (<LoadingPage />);
                                return (
                                    <IonReactRouter history={history}>
                                        <Menu routes={routes}/>
                                        <Toasts/>
                                        <IonTabs>
                                            <IonRouterOutlet animated={false} id="menutest">
                                                <Route path="/admin/:selected?/:subSelected?" exact render={(props) => 
                                                    <RequiresLogin>
                                                        <AdminOnly>
                                                            <Admin 
                                                                routes={routes}
                                                                logo={logo}
                                                                file_manager={true}
                                                                custom_menu={admin_routes}
                                                                // article_manager={article_manager} 
                                                                // custom_menu={admin_routes}
                                                                {...props} 
                                                            />
                                                        </AdminOnly>
                                                    </RequiresLogin>
                                                }/>
                                                {/* AUTH ROUTES */}
                                                <Route path="/account" exact render={(props) => 
                                                    <RequiresLogin>
                                                        <Account {...props} />
                                                    </RequiresLogin>
                                                }/>
                                                <Route path="/forgot-password" exact render={(props) => 
                                                    <RequiresLogout>
                                                        <ForgotPassword {...props} />
                                                    </RequiresLogout>
                                                }/>
                                                <Route path="/login" exact render={(props) => 
                                                    <RequiresLogout>
                                                        <Login {...props} />
                                                    </RequiresLogout>
                                                }/>
                                                <Route path="/update-password/:token" exact render={(props) => 
                                                    <UpdatePassword {...props} />
                                                }/>

                                                {/* PAGES */}
                                                <Route path="/service" exact render={(props) => 
                                                    <ServicePage {...props} />
                                                }/>
                                                <Route path="/consortium" exact render={(props) => 
                                                    <ConsortiumPage {...props} />
                                                }/>
                                                <Route path="/production-baseline" exact render={(props) => 
                                                    <PBPage {...props} />
                                                }/>
                                                <Route path="/kpi" exact render={(props) => 
                                                    <RequiresLogin>
                                                        <KPIPage {...props} />
                                                    </RequiresLogin>
                                                }/>
                                                <Route path="/utils/actions-tracking" exact render={(props) => 
                                                    <RequiresLogin>
                                                        <ActionsTrackingPage {...props} />
                                                    </RequiresLogin>
                                                }/>
                                                <Route path="/utils/documents" exact render={(props) => 
                                                    <RequiresLogin>
                                                        <DocumentsPage {...props} />
                                                    </RequiresLogin>
                                                }/>
                                                <Route path="/update-email/:token" exact render={(props) => 
                                                    <UpdateEmail {...props} />
                                                }/>
                                                <Route path="/contact" exact render={(props) => 
                                                    <Contact {...props} />
                                                }/>
                                                <Route path="/" exact render={(props) =>
                                                    <Home {...props}/> 
                                                }/>

                                                {/* =======================================
                                                        KPIS
                                                    ======================================= */}
                                                    
                                                    <Route path="/kpis/production_timeliness_-_systematic" exact render={(props) => 
                                                        <RequiresLogin>
                                                            <KPI1 />
                                                        </RequiresLogin>
                                                    }/>
                                                    <Route path="/kpis/production_completeness_-_systematic" exact render={(props) => 
                                                        <RequiresLogin>
                                                            <KPI2 />
                                                        </RequiresLogin>
                                                    }/>
                                                    <Route path="/kpis/prip_service_availability" exact render={(props) => 
                                                        <RequiresLogin>
                                                            <KPI3 />
                                                        </RequiresLogin>
                                                    }/>
                                                    <Route path="/kpis/dashboard_operations" exact render={(props) => 
                                                        <RequiresLogin>
                                                            <KPI4 />
                                                        </RequiresLogin>
                                                    }/>
                                                    <Route path="/kpis/service_reporting" exact render={(props) => 
                                                        <RequiresLogin>
                                                            <KPI5 />
                                                        </RequiresLogin>
                                                    }/>
                                                    <Route path="/kpis/cfi_data_processor_anomaly_reporting" exact render={(props) => 
                                                        <RequiresLogin>
                                                            <KPI6 />
                                                        </RequiresLogin>
                                                    }/>
                                                    <Route path="/kpis/sentinel-3_eumetsat_interfaces_performance" exact render={(props) => 
                                                        <RequiresLogin>
                                                            <KPI7 />
                                                        </RequiresLogin>
                                                    }/>
                                                    <Route path="/kpis/sentinel-3_processing_orchestration" exact render={(props) => 
                                                        <RequiresLogin>
                                                            <KPI8 />
                                                        </RequiresLogin>
                                                    }/>
                                                

                                            </IonRouterOutlet>
                                            {/* TAB BAR IS CURRENTLY DISABLED */}
                                            <IonTabBar 
                                                slot="bottom" id="tab-bar"
                                                style={isMobile && false ? undefined : { display: "none" }}
                                            >
                                                <IonTabButton tab="home" href="/">
                                                    <IonIcon icon={homeOutline} />
                                                    <IonLabel>Home</IonLabel>
                                                </IonTabButton>
                                                
                                                <IonTabButton tab="contact" href="/contact">
                                                    <IonIcon icon={informationCircleOutline} />
                                                    <IonLabel>Contact</IonLabel>
                                                </IonTabButton>
                                                <IonTabButton tab="account" href="/account">
                                                    <IonIcon icon={personCircleOutline} />
                                                    <IonLabel>Account</IonLabel>
                                                </IonTabButton>
                                            </IonTabBar>
                                        </IonTabs>
                                    </IonReactRouter>
                                )
                            }
                        }
                    }
                </Async>
            </IonApp>
        )
    }
};

const mapStateToProps = (state: any) => {
    return {
        login: state.login,
        // notifications: state.notifications,
    }
}

// export default App;
export default connect(mapStateToProps,{ setArticleManager, setCatalog, setRouting })(App);
